<template>
  <div class="sidebar-box category-box mt-6 p-5">
    <h4 class="mb-3" v-t="`post.filter_category.title`"></h4>
    <m-categories-wrapper>
      <template v-slot="{categories,setLinkType,clearRouter}">
        <ul>
          <li>
            <m-a :href="clearRouter('blog')">
              <span v-t="`post.filter_category.first_item`"></span>
            </m-a>
          </li>

          <li v-for="category in categoryShape(categories)" :key="category.id" >
            <m-a :href="setLinkType(category,'blog')" class="text-decoration-none"><span>{{ category.name }}</span>
            </m-a>
          </li>
        </ul>
      </template>
    </m-categories-wrapper>

  </div>
</template>

<script>
import {categoryPanelProps} from './CategoryPanelProps'
import {categoryMethods} from "../CategoriesMethods";
import mCategoriesWrapper from "../../Wrappers/CategoryWrapper";
import mA from "../../Tags/A";

export default {
  name: "CategoriesPanel301",
  components: {mCategoriesWrapper, mA},
  props: categoryPanelProps,
  methods: categoryMethods,
}
</script>

<style scoped>

.sidebar-box {
  /*padding: 15px;*/
  border-radius: 10px;
  background: white;
  box-shadow: 0px 5px 25px rgba(218, 211, 211, 0.3);
  margin-bottom: 30px;
  border: 1px solid #F5F4F4;
}

.sidebar-box > form > input {
  width: 90%;
  border: none;
  background: transparent;

}

.sidebar-box ul li {
  padding-right: 25px;

  margin-bottom: 20px;
}

.sidebar-box ul li a {
  color: var(--dark);
}

</style>